import { render, staticRenderFns } from "./order-shipment-stat.vue?vue&type=template&id=3ca0142d&scoped=true"
import script from "./order-shipment-stat.vue?vue&type=script&lang=js"
export * from "./order-shipment-stat.vue?vue&type=script&lang=js"
import style0 from "./order-shipment-stat.vue?vue&type=style&index=0&id=3ca0142d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0142d",
  null
  
)

export default component.exports